import Image from 'next/image';
import { TOTAL_REVIEWS } from '@/lib/google-reviews/counts';
import leah from '../images/customer-avatars/leah.png';
import amyjane from '../images/customer-avatars/amyjane.png';
import nicola from '../images/customer-avatars/nicola.png';

const AVATARS_SHOWN = 3;

export default function AvatarStack() {
  return (
    <div className="flex -space-x-4 rtl:space-x-reverse">
      <Image
        className="h-10 w-10 rounded-full  border-white "
        src={leah}
        alt=""
        height={20}
        width={20}
      />
      <Image
        className="h-10 w-10 rounded-full  border-white "
        src={amyjane}
        alt=""
        height={20}
        width={20}
      />
      <Image
        className="h-10 w-10 rounded-full  border-white "
        src={nicola}
        alt=""
        height={20}
        width={20}
      />
      <a
        className="flex h-10 w-10 items-center justify-center rounded-full  border-white bg-gray-700 text-xs font-medium text-white hover:bg-gray-600 "
        href="#testimonials-horizontal-scroller"
        aria-label={`Read all ${TOTAL_REVIEWS} reviews`}
      >
        {/* three faces are shown above, so the badge counts the rest */}
        +{TOTAL_REVIEWS - AVATARS_SHOWN}
      </a>
    </div>
  );
}
